export type Base = 'tres_meses' | 'seis_meses' | 'anual'

export interface EstadoDestrave {
  destravado: boolean
  diasFaltando: number
  dataDeDestrave: string | null // ISO; null quando nem da para prever
}

export function mesDe(iso: string): string {
  return iso.slice(0, 7)
}

function partes(mes: string): [number, number] {
  const [ano, m] = mes.split('-').map(Number)
  return [ano, m]
}

export function primeiroDiaDoMes(mes: string): string {
  return `${mes}-01`
}

export function ultimoDiaDoMes(mes: string): string {
  const [ano, m] = partes(mes)
  const dia = new Date(ano, m, 0).getDate() // dia 0 do mes seguinte = ultimo deste
  return `${mes}-${String(dia).padStart(2, '0')}`
}

function somarMeses(mes: string, quantos: number): string {
  const [ano, m] = partes(mes)
  const d = new Date(ano, m - 1 + quantos, 1)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

export function diasEntreDatas(de: Date, ate: string): number {
  const [ano, m, dia] = ate.split('-').map(Number)
  const alvo = new Date(ano, m - 1, dia)
  const inicio = new Date(de.getFullYear(), de.getMonth(), de.getDate())
  return Math.max(0, Math.round((alvo.getTime() - inicio.getTime()) / 86_400_000))
}

// So meses JA FECHADOS. O mes corrente nao entra: ele ainda pode virar
// qualquer coisa, e a media de um mes pela metade nao significa nada.
export function mesesFechados(primeiroMes: string, hoje: Date): string[] {
  const mesCorrente = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`
  const lista: string[] = []
  let atual = primeiroMes
  while (atual < mesCorrente) {
    lista.push(atual)
    atual = somarMeses(atual, 1)
  }
  return lista
}

const MESES_EXIGIDOS: Record<'tres_meses' | 'seis_meses', number> = {
  tres_meses: 3,
  seis_meses: 6,
}

// ⚠ O destrave e por TEMPO DE CALENDARIO, nao por meses com venda. Ela pediu a
// contagem em DIAS (spec §7), e um numero em dias so existe se a data for
// previsivel. Se um mes zerado quebrasse a contagem, o contador andaria para
// tras quando o mes fechasse vazio.
export function destraveDaBase(
  base: Base,
  primeiroMesComVenda: string | null,
  mesAlvo: string,
  hoje: Date,
): EstadoDestrave {
  if (!primeiroMesComVenda) {
    return { destravado: false, diasFaltando: 0, dataDeDestrave: null }
  }

  if (base === 'anual') {
    // Exige o MESMO mes em algum ano anterior, com venda. Entao o primeiro
    // mes-alvo servido e o mesmo mes do primeiro ano com venda, um ano depois.
    const [anoAlvo, mAlvo] = partes(mesAlvo)
    const [anoPrimeiro, mPrimeiro] = partes(primeiroMesComVenda)
    const contraparteExiste =
      anoAlvo > anoPrimeiro || (anoAlvo === anoPrimeiro && mAlvo >= mPrimeiro)
        ? `${anoAlvo - 1}-${String(mAlvo).padStart(2, '0')}` >= primeiroMesComVenda
        : false
    if (contraparteExiste) {
      return { destravado: true, diasFaltando: 0, dataDeDestrave: null }
    }
    const primeiroServido = `${anoPrimeiro + 1}-${String(mPrimeiro).padStart(2, '0')}`
    const data = primeiroDiaDoMes(primeiroServido)
    return { destravado: false, diasFaltando: diasEntreDatas(hoje, data), dataDeDestrave: data }
  }

  const exigidos = MESES_EXIGIDOS[base]
  const fechados = mesesFechados(primeiroMesComVenda, hoje)
  if (fechados.length >= exigidos) {
    return { destravado: true, diasFaltando: 0, dataDeDestrave: null }
  }
  const mesQueDestrava = somarMeses(primeiroMesComVenda, exigidos)
  const data = primeiroDiaDoMes(mesQueDestrava)
  return { destravado: false, diasFaltando: diasEntreDatas(hoje, data), dataDeDestrave: data }
}
